import React, { useContext } from 'react';
import PageContent from '../components/PageContent';
import Banner from '../components/Banner';
import Section from '../components/Section';
import { Row, Col } from '../styles/utils/Grid';
import TwoOptionsButton from '../components/TwoOptionsButton';
import { useInputState, useValidation } from '../hooks';
import PersonalDataPJ from '../components/PersonalDataPJ/PersonalDataPJ';
import PersonalDataPF from '../components/PersonalDataPF';
import { AppContext } from '../context';
import { FlatButton } from '../components/Button';
import { handleChange } from '../utils/inputEvents';
import { required } from '../utils/inputValidation';
import { registerBannerTitle } from '../utils/constants';
import DataConsentQuestion from '../components/DataConsentQuestion';

const MobileRegisterPersonal = () => {
  const [type, setType, typeRef, validateType] = useInputState('Física');
  const [personalDataPfRef, validatePersonalDataPf] = useValidation();
  const [personalDataPjRef, validatePersonalDataPj] = useValidation();
  const { setContext, userData = {} } = useContext(AppContext);

  const submit = () => {
    let personalData = {};
    const validType = validateType();
    if (validType) {
      return;
    }
    if (type.value === 'Física') {
      personalData = validatePersonalDataPf();
    } else {
      personalData = validatePersonalDataPj();
    }

    if (personalData.invalid) {
      return;
    }

    setContext({
      userData: {
        pessoa: {
          ...userData?.pessoa,
          ...personalData.value,
        },
      },
      navigateTo: '/endereco',
    });
  };
  return (
    <PageContent step={2}>
      <Banner title={registerBannerTitle} />
      <Section title="Você é uma pessoa:" style={{ display: 'none' }}>
        <Row>
          <Col col={45}>
            <TwoOptionsButton
              options={['Física', 'Jurídica']}
              value={type.value}
              invalid={type.invalid}
              type="button"
              errorMessage={type.errorMessage}
              onClick={handleChange(setType)}
              ref={typeRef}
              validations={[required]}
            />
          </Col>
        </Row>
      </Section>

      {type?.value === 'Física' ? (
        <PersonalDataPF
          ref={personalDataPfRef}
          personalData={userData?.pessoa}
          setContext={setContext}
        />
      ) : (
        <PersonalDataPJ
          ref={personalDataPjRef}
          personalData={userData?.pessoa}
          setContext={setContext}
        />
      )}
      <DataConsentQuestion marginBottom />
      <Section flexEnd noPadding bgTransparent inlineChildren>
        <FlatButton
          column
          hasArrow
          back
          arrowDirection="left"
          arrowSize={5}
          onClick={() => {
            setContext({
              navigateTo: '/objetivo',
            });
          }}
          margin
        >
          Voltar
        </FlatButton>
        <FlatButton
          column
          hasArrow
          inverse
          arrowDirection="right"
          arrowSize={5}
          onClick={submit}
        >
          Continuar
        </FlatButton>
      </Section>
    </PageContent>
  );
};

export default MobileRegisterPersonal;
